// services/subject.js
import axios from './api';


// List with optional query params: { q, page, limit, active, sort }

export const fetchSubjects = async (params = {}) => {
  const { q, active = true, page = 1, limit = 250 } = params;
  const res = await axios.get('/subject', { params: { q, active, page, limit } });
  return res.data; // { items, total, page, pages }
};

export const createSubject = async (payload) => {
  const res = await axios.post('/subject', payload);
  return res.data;
};

export const updateSubject = async (id, payload) => {
  const res = await axios.put(`/subject/${id}`, payload);
  return res.data;
};

export const deleteSubject = async (id) => {
  const res = await axios.delete(`/subject/${id}`);
  return res.data;
};

export const toggleSubject = async (id) => {
  const res = await axios.patch(`/subject/${id}/toggle`);
  return res.data;
};

// Export subjects as Blob
export const exportSubjectsFile = async ({ format = 'csv', active } = {}) => {
  const res = await axios.get('/subject/export/all', {
    params: { format, active },
    responseType: 'blob',
  });
  return res.data;
};

// Import subjects via file
export const importSubjectsFile = async (file) => {
  if (!file) throw new Error('No file provided');
  const fd = new FormData();
  fd.append('file', file);
  const res = await axios.post('/subject/import', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

